import { createSlice } from '@reduxjs/toolkit';

export const persistKeyboard = createSlice({
  name: 'PERSIST_KEYBOARD',
  initialState: {}, // declare in store, not here as it will be over written by store

  reducers: {
    setComponentIdToReceiveFocus(state, action) {
      const { payload } = action;
      const { componentIdToReceiveFocus } = payload;
      return {
        ...state,
        componentIdToReceiveFocus,
      };
    },
  },
});

const { actions, reducer } = persistKeyboard;

export const { setComponentIdToReceiveFocus } = actions;

export default reducer;
